import API from '../api'
import postUrl from './paths'

export const migrateOrgToOracle = (
	orgId,
	role,
	commodityName = null,
	skipChecks = true,
	gstNumbers,
	tradeName,
	projectCode,
	projectSites,
	subsidiaryId
) =>
	new Promise((resolve, reject) => {
		API.post(
			postUrl.migrateOrganisationsToOracle,
			{},
			{ orgId, role, commodityName, skipChecks, gstNumbers, tradeName, projectCode, projectSites, subsidiaryId }
		)
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
